
import React from 'react';
import actions from '../actions/TransportAction';
var axios = require('axios');
var constants = require("../constants/constants");
var trstyle = {
    float: 'right',
    margin: '10px 10px 0px 0px'
}
export default class TransportInformation extends React.Component {
    constructor(props) {
        super(props);
        let CompanyId = localStorage.getItem('CompanyId') || 1;
        this.state = {
            Transport_VehiclesId: props.location.isEditCall ? props.location.editVehicleData.Transport_VehiclesId : '',
            GadiPrakar: props.location.isEditCall ? props.location.editVehicleData.VehicleTypesID : '',
            GadiNo: props.location.isEditCall ? props.location.editVehicleData.VehicleNo : '',
            GadiPassinDate: props.location.isEditCall ? props.location.editVehicleData.Passingdate : '',
            VimaPolicyNo: props.location.isEditCall ? props.location.editVehicleData.PolicyNo : '',
            VimaCompanyName: props.location.isEditCall ? props.location.editVehicleData.InsurancceCompanyName : '',
            VimaStartDate: props.location.isEditCall ? props.location.editVehicleData.InsurancceStartDate : '',
            VimaVedhataDate: props.location.isEditCall ? props.location.editVehicleData.InsurancceEndDate : '',
            DistrictList: [],
            TalukaList: [],
            VillageList: [],
            VehicleList: [],
            CompanyId: CompanyId,
        };
    }

    componentWillMount() {
        var user = JSON.parse(sessionStorage.getItem("User"));
        let currentComponent = this;
        axios.get(constants.config.HOST + constants.api.GET_VEHICLE_TYPE_INFO, {
            params: { YearId: user.TargetYearId }
        }).then(function (response) {
            currentComponent.setState({ VehicleList: response.data })
            console.log(response.data)
        }).catch(function (error) {
            console.log(error);
        });
    }

    addVehicle(e) {
        e.preventDefault();
        if (this.validation())
            actions.addVehicle(this.state);
        else
            return false;
        this.props.history.push('/VehicleFillInfo_Show_Details')
    }

    UpdateVehicle(e) {
        e.preventDefault();
        console.log(this.state)
        actions.UpdateVehicle(this.state);
    }

    handleInputChange(e) {
        e.preventDefault();
        var name = e.target.name;
        var state = this.state;
        state[name] = e.target.value;
        this.setState(state);
    }

    //only alphabet validation

    validation() {
        var validator = true;
        var errmsg = '';
        // remove already error element
        try {
            var elements = document.getElementsByClassName('help-block');
            while (elements.length > 0) {
                elements[0].parentNode.removeChild(elements[0]);
            }
        } catch (e) {
        }
        //validation code start
        var form = document.getElementById('theForm');
        for (var i = 0; i < form.elements.length; i++) {
            if (form.elements[i].value === '' && form.elements[i].hasAttribute('required')) {
                errmsg = '';
                errmsg = form.elements[i].getAttribute("data-msg");
                if (errmsg != '') {
                    var ele = document.createElement("span");
                    ele.classList.add('help-block');
                    ele.textContent = errmsg;
                    form.elements[i].parentElement.appendChild(ele);
                }
                form.elements[i].parentElement.classList.add("has-error");
                validator = false;
            }
            else {
                form.elements[i].parentElement.classList.remove("has-error")
            }
        }
        return validator;
    }

    render() {
        var styleone = {
            borderwidth: "10px",
            buttoncolor: "#3F51B5",
            buttonwidht: "40px",
        }
        let currentComponent = this;
        let gadiPrakar = this.state.VehicleList.find(function (vehicle) {
            return vehicle.VehicleTypesID == currentComponent.state.GadiPrakar
        })

        return (
            <div className="pages">
                <div data-page="form" className="page no-toolbar no-navbar">
                    <div className="page-content">
                        <div className="navbarpages navbarpagesbg">
                            <div className="navbar_left">
                                <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
                            </div>
                            <div className="navbar_right">
                                <a href="/UserProfile" className="external"><img src="images/icons/white/user.png" alt="" title="" /></a>
                            </div>
                        </div>
                        <div id="pages_maincontent">
                            <h3 style={{ 'color': '#0000FF' }}><b style={{ 'padding-left': '80px' }}>वाहनांची माहिती</b></h3>
                            <div className="page_single layout_fullwidth_padding">
                                <div className="contactform">
                                    <form className="" id="CustomForm" method="post" action="">
                                        <form id="theForm">
                                            <fieldset>
                                                <div className="form_row custom_select">
                                                    <a href="#" className="item-link smart-select" data-open-in="picker">
                                                        <div className="item-content">
                                                            <div className="item-inner">
                                                                <label>वाहनाचा प्रकार  :</label>
                                                                <div className="item-after">{gadiPrakar == undefined ? 'Select' : gadiPrakar.Name}</div>
                                                            </div>
                                                            <select id='GadiPrakar' className="required " name='GadiPrakar' value={this.state.GadiPrakar} onChange={(e) => this.handleInputChange(e)}>
                                                                <option value="0">Select</option>
                                                                {
                                                                    this.state.VehicleList.map(Vehicle => <option value={Vehicle.VehicleTypesID}>{Vehicle.Name}</option>)
                                                                }
                                                            </select>
                                                        </div>
                                                    </a>
                                                    <div class="form_row">
                                                        <label htmlFor="GadiNo">वाहन नंबर :</label>
                                                        <input type="text" class="form_input" id="GadiNo" data-msg=" **** वाहन  न. आवश्यक****" name="GadiNo" value={this.state.GadiNo}
                                                            onChange={(e) => this.handleInputChange(e)} placeholder="वाहन  नंबर भरा  " required />
                                                    </div>
                                                    <div class="form_row">
                                                        <label htmlFor="GadiPassinDate">वाहन पासिंग तारीख :</label>
                                                        <input type="text" class="form_input" id="GadiPassinDate" data-msg=" **** तारीख आवश्यक ****" name="GadiPassinDate" value={this.state.GadiPassinDate}
                                                            onChange={(e) => this.handleInputChange(e)} placeholder="महिना-दिवस-वर्ष " required />
                                                    </div>
                                                    <div class="form_row">
                                                        <h3 style={{ 'color': '#0000FF' }}><b style={{ 'padding-left': '80px' }}>वाहन विमा </b></h3>
                                                    </div>
                                                    <div class="form_row">
                                                        <label htmlFor="VimaPolicyNo">वाहन policy No :</label>
                                                        <input type="Number" class="form_input" id="VimaPolicyNo" name="VimaPolicyNo" data-msg=" **** वाहन policy No ****" value={this.state.VimaPolicyNo} onChange
                                                            ={(e) => this.handleInputChange(e)} placeholder="वाहन policy नंबर भरा " required />

                                                    </div>
                                                    <div class="form_row">
                                                        <label htmlFor="VimaCompanyName">वाहन कंपनी नाव :</label>
                                                        <input ref="name" type="text" class="form_input" id="VimaCompanyName" name="VimaCompanyName" data-msg=" **** वाहन कंपनी नाव आवश्यक ****" maxLength="10" value={this.state.VimaCompanyName} onChange
                                                            ={(e) => this.handleInputChange(e)} placeholder="वाहन कंपनी नाव भरा " pattern='[A-Za-z\\s]*' required />

                                                    </div>
                                                    <div class="form_row">
                                                        <label htmlFor="VimaStartDate">वाहन विमा तारीख  :</label>
                                                        <input type="text" class="form_input" id="VimaStartDate" data-msg=" ****तारीख आवश्यक****" name="VimaStartDate" class="form_input required" value={this.state.VimaStartDate}
                                                            onChange={(e) => this.handleInputChange(e)} placeholder="महिना-दिवस-वर्ष" required />
                                                    </div>
                                                    <div class="form_row">
                                                        <label htmlFor="VimaVedhataDate">विमा वैधता तारीख :</label>
                                                        <input type="text" class="form_input" id="VimaVedhataDate" data-msg=" **** तारीख आवश्यक ****" name="VimaVedhataDate" value={this.state.VimaVedhataDate}
                                                            onChange={(e) => this.handleInputChange(e)} placeholder="महिना-दिवस-वर्ष" required />
                                                    </div>
                                                    <br />

                                                    <div className="form-group">
                                                        {this.props.location.isEditCall ? <button class="btn  btn-primary" type="submit" style={trstyle} onClick={(e) => this.UpdateVehicle(e)}>Update करा </button>
                                                            : <button class="btn  btn-primary" style={trstyle} type="submit" onClick={(e) => this.addVehicle(e, currentComponent.state.CompanyId)}> ✔ Save करा </button>}

                                                        {/* <button className="btn btn-primary" style={styleone} onClick={this.handleClick} type="submit" onClick={(e) => this.addVehicle(e)}>Save करा </button> */}
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </form>
                                    </ form>
                                </ div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }

}



// WEBPACK FOOTER //
// ./src/component/TransportInformation.jsx